import { render, staticRenderFns } from "./SCamera.vue?vue&type=template&id=57cd69d2&scoped=true&"
import script from "./SCamera.vue?vue&type=script&lang=js&"
export * from "./SCamera.vue?vue&type=script&lang=js&"
import style0 from "./SCamera.vue?vue&type=style&index=0&id=57cd69d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cd69d2",
  null
  
)

export default component.exports